(() => {
  const money = cents => new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format((Number(cents) || 0) / 100);

  const notice = document.querySelector('[data-notice]');
  const noticeCard = notice?.querySelector('.notice-card');
  const noticeTitle = notice?.querySelector('[data-notice-title]');
  const noticeMessage = notice?.querySelector('[data-notice-message]');
  const noticeKicker = notice?.querySelector('[data-notice-kicker]');
  const noticeAction = notice?.querySelector('[data-notice-action]');
  let noticeReturnFocus = null;
  const closeNotice = () => {
    if (!notice || notice.hidden) return;
    notice.hidden = true;
    document.body.classList.remove('notice-open');
    const target = noticeReturnFocus;
    noticeReturnFocus = null;
    target?.focus();
  };
  const showNotice = ({ title = 'Please check the form', message, kicker = 'We need one detail', field = null, action = 'Fix this field' }) => {
    if (!notice) return;
    noticeReturnFocus = field || document.activeElement;
    noticeTitle.textContent = title;
    noticeMessage.textContent = message;
    noticeKicker.textContent = kicker;
    noticeAction.textContent = action;
    notice.hidden = false;
    document.body.classList.add('notice-open');
    noticeCard.focus();
  };
  const showToast = message => {
    const region = document.querySelector('[data-toast-region]');
    if (!region) return;
    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.textContent = message;
    region.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('show'));
    setTimeout(() => { toast.classList.remove('show'); setTimeout(() => toast.remove(), 250); }, 4200);
  };
  const fieldName = field => {
    const label = field.id && document.querySelector(`label[for="${CSS.escape(field.id)}"]`);
    return (label?.textContent || field.getAttribute('aria-label') || field.name || 'this field').replace(/optional/gi, '').trim();
  };
  const validationMessage = field => {
    const name = fieldName(field);
    if (field.validity.valueMissing) return `Please complete ${name}.`;
    if (field.validity.typeMismatch && field.type === 'email') return 'Enter a valid email address, such as name@example.com.';
    if (field.validity.tooShort) return `${name} needs at least ${field.minLength} characters.`;
    if (field.validity.rangeUnderflow) return `${name} must be at least ${field.min}.`;
    if (field.validity.rangeOverflow) return `${name} must be ${field.max} or less.`;
    return `Please review ${name} and try again.`;
  };
  window.TFP = { showNotice, showToast };
  notice?.querySelectorAll('[data-notice-close]').forEach(button => button.addEventListener('click', closeNotice));
  noticeAction?.addEventListener('click', closeNotice);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeNotice(); nav?.classList.remove('open'); navToggle?.setAttribute('aria-expanded', 'false'); } });
  document.addEventListener('invalid', event => {
    event.preventDefault();
    if (notice && !notice.hidden) return;
    showNotice({ message: validationMessage(event.target), field: event.target });
  }, true);

  const navToggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (navToggle && nav) navToggle.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    navToggle.setAttribute('aria-expanded', String(open));
  });

  document.querySelectorAll('[data-product-root]').forEach(root => {
    const form = root.querySelector('#tfp-product-form');
    const variantSelect = root.querySelector('[data-variant-select]');
    const priceOutput = root.querySelector('[data-product-price]');
    const width = root.querySelector('[data-width]');
    const length = root.querySelector('[data-length]');
    const quantity = root.querySelector('[data-quantity]');
    const pieceQuantity = root.querySelector('[data-piece-quantity]');
    const sqftProperty = root.querySelector('[data-sqft-property]');
    const sqftOutput = root.querySelector('[data-sqft-output]');
    const totalSqftOutput = root.querySelector('[data-total-sqft-output]');
    const estimate = root.querySelector('[data-estimate]');
    const status = root.querySelector('[data-form-status]');
    const fileInput = root.querySelector('[data-artwork-file]');
    const uploadPanel = root.querySelector('[data-upload-panel]');

    const variantPrice = () => {
      if (!variantSelect) return 0;
      const option = variantSelect.options ? variantSelect.options[variantSelect.selectedIndex] : variantSelect;
      return Number(option?.dataset.price || 0);
    };
    const calculate = () => {
      const price = variantPrice();
      if (priceOutput) priceOutput.textContent = `${money(price)}${root.dataset.unitSqft === 'true' ? '/sq. ft.' : ''}`;
      if (!width || !length) return;
      const area = Math.max(1, Math.ceil((Number(width.value) || 0) * (Number(length.value) || 0)));
      const pieces = Math.max(1, Math.floor(Number(pieceQuantity?.value) || 1));
      const totalArea = area * pieces;
      quantity.value = String(totalArea);
      sqftProperty.value = `${area} sq ft each × ${pieces} piece${pieces === 1 ? '' : 's'} = ${totalArea} sq ft total`;
      sqftOutput.textContent = `${area} sq ft`;
      if (totalSqftOutput) totalSqftOutput.textContent = `${totalArea} sq ft`;
      estimate.textContent = money(price * totalArea);
    };
    variantSelect?.addEventListener('change', calculate);
    width?.addEventListener('input', calculate);
    length?.addEventListener('input', calculate);
    pieceQuantity?.addEventListener('input', calculate);
    calculate();

    root.querySelectorAll('[data-artwork-choice]').forEach(choice => choice.addEventListener('change', () => {
      const mode = root.querySelector('[data-artwork-choice]:checked')?.dataset.artworkChoice;
      if (uploadPanel) uploadPanel.hidden = mode !== 'upload';
    }));

    form?.addEventListener('submit', event => {
      const artworkMode = root.querySelector('[data-artwork-choice]:checked')?.dataset.artworkChoice;
      if (artworkMode === 'upload' && fileInput && !fileInput.files.length) {
        event.preventDefault();
        status.textContent = 'Please attach your artwork, or choose “Send artwork later.”';
        status.classList.add('error');
        showNotice({ title: 'Artwork file needed', message: status.textContent, field: fileInput, action: 'Choose a file' });
      }
    });

  });

  const assistant = document.querySelector('[data-print-assistant]');
  if (assistant) {
    const launcher = assistant.querySelector('[data-assistant-toggle]');
    const panel = assistant.querySelector('[data-assistant-panel]');
    const close = assistant.querySelector('[data-assistant-close]');
    const messages = assistant.querySelector('[data-assistant-messages]');
    const choices = assistant.querySelector('[data-assistant-choices]');
    const form = assistant.querySelector('[data-assistant-form]');
    const input = assistant.querySelector('[data-assistant-input]');
    const replies = {
      product: 'Tell us what you are making, the finished size, quantity, where it will be used and your deadline. For stickers, start with Stickers & Labels; for rigid displays, start with Signs & Displays.',
      artwork: 'Vector PDF, AI, EPS or SVG is preferred. Raster files should be 300 dpi at finished size. Every custom order is reviewed and proofed before production.',
      turnaround: 'Production begins after payment and proof approval. Timing varies by product and quantity, so please confirm any firm event or campaign date before ordering.',
      floor: 'Floor wraps can be white or black, matte or gloss, and ordered plain, with a monogram, or as a full-print design. We need the finished dimensions, venue details and event date.',
      human: 'A print specialist can take over. Call (647) 217-9866, email Order@TorontosFinestPrint.com, or use the live Shopify Inbox conversation when it is available.'
    };
    const addMessage = (text, who = 'bot') => { const item = document.createElement('div'); item.className = `assistant-message ${who}`; item.textContent = text; messages.appendChild(item); messages.scrollTop = messages.scrollHeight; };
    const toggle = open => { panel.hidden = !open; launcher.setAttribute('aria-expanded', String(open)); if (open) input.focus(); };
    launcher.addEventListener('click', () => toggle(panel.hidden));
    close.addEventListener('click', () => toggle(false));
    choices.addEventListener('click', event => { const button = event.target.closest('[data-assistant-topic]'); if (!button) return; addMessage(button.textContent, 'customer'); addMessage(replies[button.dataset.assistantTopic]); });
    form.addEventListener('submit', event => { event.preventDefault(); const question = input.value.trim(); if (!question) return; addMessage(question, 'customer'); input.value = ''; const key = /floor|dance|event/.test(question.toLowerCase()) ? 'floor' : /file|art|design|pdf|logo/.test(question.toLowerCase()) ? 'artwork' : /time|fast|ready|deadline/.test(question.toLowerCase()) ? 'turnaround' : /person|human|call|agent/.test(question.toLowerCase()) ? 'human' : 'product'; setTimeout(() => addMessage(replies[key]), 250); });
  }

  window.addEventListener('offline', () => showToast('You appear to be offline. Your information has not been submitted.'));
  window.addEventListener('online', () => showToast('You’re back online. You can continue.'));
  /* Floor pricing calculator v2 */
  document.querySelectorAll('[data-product-root]').forEach(root => {
    const handle = location.pathname.split('/products/')[1]?.split(/[?#/]/)[0];
    if (!['indoor-floor-graphics', 'outdoor-floor-decals'].includes(handle)) return;

    const form = root.querySelector('#tfp-product-form');
    const oldCalculator = root.querySelector('.sqft-calculator');
    const quantity = root.querySelector('[data-quantity]');
    const variantSelect = root.querySelector('[data-variant-select]');
    if (!form || !oldCalculator || !quantity || !variantSelect) return;

    const monogramVariants = {
      none: null,
      white: '47243864801436',
      black: '47243864834204',
      gold: '47243864866972',
      silver: '47243864899740'
    };
    const monogramRates = { none: 0, white: 120, black: 153, gold: 120, silver: 120 };
    const installationVariant = '47243628118172';

    oldCalculator.innerHTML = `
      <legend>Floor wrap calculator</legend>
      <div class="field-grid two">
        <div class="field-group"><label>Floor width (feet)</label><input type="number" name="properties[Floor width (ft)]" min="0.1" step="0.1" inputmode="decimal" required data-floor-width></div>
        <div class="field-group"><label>Floor length (feet)</label><input type="number" name="properties[Floor length (ft)]" min="0.1" step="0.1" inputmode="decimal" required data-floor-length></div>
      </div>
      <input type="hidden" name="properties[Floor billable area]" data-sqft-property>
      <div class="calculation-line"><span>Floor wrap area (rounded up)</span><strong data-floor-area>1 sq ft</strong></div>
      <div class="calculation-line"><span>Floor wrap subtotal</span><strong data-floor-subtotal>$0.00</strong></div>
      <div class="field-group"><label for="MonogramMaterial">Monogram</label><select id="MonogramMaterial" data-monogram-material><option value="none">No monogram</option><option value="white">White vinyl — $1.20/sq. ft.</option><option value="black">Black vinyl — $1.53/sq. ft.</option><option value="gold">Gold chrome — $1.20/sq. ft.</option><option value="silver">Silver chrome — $1.20/sq. ft.</option></select></div>
      <div class="field-grid two" data-monogram-dimensions hidden>
        <div class="field-group"><label>Monogram width (feet)</label><input type="number" min="0.01" step="0.01" inputmode="decimal" data-monogram-width></div>
        <div class="field-group"><label>Monogram length (feet)</label><input type="number" min="0.01" step="0.01" inputmode="decimal" data-monogram-length></div>
      </div>
      <div class="calculation-line" data-monogram-line hidden><span>Monogram subtotal</span><strong data-monogram-subtotal>$0.00</strong></div>
      <label class="choice"><input type="checkbox" data-installation><span><strong>Professional installation (+$350)</strong><small>Includes removal. Added once per floor-wrap order.</small></span></label>
      <div class="calculation-line total"><span>Estimated total</span><strong data-estimate>$0.00</strong></div>
      <small class="calculator-note">Floor and monogram dimensions are calculated independently. Each area is rounded up to the next whole square foot.</small>
    `;

    const $ = selector => oldCalculator.querySelector(selector);
    const floorWidth = $('[data-floor-width]');
    const floorLength = $('[data-floor-length]');
    const floorAreaOut = $('[data-floor-area]');
    const floorSubtotalOut = $('[data-floor-subtotal]');
    const monoMaterial = $('[data-monogram-material]');
    const monoDimensions = $('[data-monogram-dimensions]');
    const monoWidth = $('[data-monogram-width]');
    const monoLength = $('[data-monogram-length]');
    const monoLine = $('[data-monogram-line]');
    const monoSubtotalOut = $('[data-monogram-subtotal]');
    const install = $('[data-installation]');
    const totalOut = $('[data-estimate]');
    const sqftProperty = $('[data-sqft-property]');
    const billable = (w, l) => Math.max(0, Math.ceil((Number(w.value) || 0) * (Number(l.value) || 0)));
    const selectedFloorPrice = () => {
      const option = variantSelect.options ? variantSelect.options[variantSelect.selectedIndex] : variantSelect;
      return Number(option?.dataset.price || 0);
    };
    const totals = () => {
      const floorArea = billable(floorWidth, floorLength);
      const monoChoice = monoMaterial.value;
      const monoArea = monoChoice === 'none' ? 0 : billable(monoWidth, monoLength);
      const floorCents = floorArea * selectedFloorPrice();
      const monoCents = monoArea * monogramRates[monoChoice];
      const installCents = install.checked ? 35000 : 0;
      quantity.value = String(Math.max(1, floorArea));
      sqftProperty.value = `${floorArea} sq ft`;
      floorAreaOut.textContent = `${floorArea} sq ft`;
      floorSubtotalOut.textContent = money(floorCents);
      monoSubtotalOut.textContent = money(monoCents);
      totalOut.textContent = money(floorCents + monoCents + installCents);
      return { floorArea, monoChoice, monoArea };
    };
    monoMaterial.addEventListener('change', () => {
      const enabled = monoMaterial.value !== 'none';
      monoDimensions.hidden = !enabled;
      monoLine.hidden = !enabled;
      monoWidth.required = enabled;
      monoLength.required = enabled;
      totals();
    });
    [floorWidth, floorLength, monoWidth, monoLength, install, variantSelect].forEach(el => el?.addEventListener('input', totals));
    variantSelect?.addEventListener('change', totals);
    totals();

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const { floorArea, monoChoice, monoArea } = totals();
      if (floorArea < 1) {
        showNotice({ message: 'Enter the finished floor width and length.', field: floorWidth });
        return;
      }
      const floorVariantId = variantSelect.value;
      const properties = {
        'Floor width (ft)': floorWidth.value,
        'Floor length (ft)': floorLength.value,
        'Floor billable area': `${floorArea} sq ft`
      };
      const items = [{ id: Number(floorVariantId), quantity: floorArea, properties }];
      if (monoChoice !== 'none') {
        items.push({
          id: Number(monogramVariants[monoChoice]),
          quantity: monoArea,
          properties: {
            'For floor wrap': handle,
            'Monogram width (ft)': monoWidth.value,
            'Monogram length (ft)': monoLength.value,
            'Monogram billable area': `${monoArea} sq ft`
          }
        });
      }
      if (install.checked) items.push({ id: Number(installationVariant), quantity: 1, properties: { 'For floor wrap': handle } });

      const button = form.querySelector('[type="submit"]');
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart request failed');
        location.assign('/cart');
      } catch (error) {
        button.disabled = false;
        button.textContent = 'Add to cart';
        showNotice({ title: 'Could not add this configuration', message: 'Please try again. If the problem continues, contact Toronto’s Finest Print.', action: 'Try again' });
      }
    });
  });

  document.querySelectorAll('[data-high-variant-product="true"]').forEach(root => {
    const priceOutput = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('.add-button');
    let requestController;

    const formatQuantityOptions = fragment => {
      fragment.querySelectorAll('[data-option-name="Quantity"] option').forEach(option => {
        option.textContent = Number(option.textContent).toLocaleString('en-CA');
      });
    };

    const updateProductUi = fragment => {
      if (priceOutput) priceOutput.textContent = fragment.dataset.priceFormatted;
      if (addButton) {
        const available = fragment.dataset.available === 'true';
        addButton.disabled = !available;
        addButton.textContent = available ? fragment.dataset.addText : fragment.dataset.soldOutText;
      }
    };

    formatQuantityOptions(root);

    root.addEventListener('change', async event => {
      if (!event.target.matches('[data-high-variant-option]')) return;
      const fragment = event.target.closest('[data-high-variant-fragment]');
      const selects = [...fragment.querySelectorAll('[data-high-variant-option]')];
      const selectedValues = selects.map(select => select.value).filter(Boolean);
      if (selectedValues.length !== selects.length) return;

      requestController?.abort();
      requestController = new AbortController();
      fragment.setAttribute('aria-busy', 'true');
      selects.forEach(select => { select.disabled = true; });
      const status = fragment.querySelector('[data-high-variant-status]');
      if (status) status.textContent = fragment.dataset.loadingText;

      const selectedOption = event.target.options[event.target.selectedIndex];
      const productUrl = selectedOption.dataset.productUrl || fragment.dataset.productUrl;
      const requestUrl = new URL(productUrl, location.origin);
      requestUrl.searchParams.set('section_id', fragment.dataset.sectionId);
      requestUrl.searchParams.set('option_values', selectedValues.join(','));

      try {
        const response = await fetch(requestUrl, { signal: requestController.signal });
        if (!response.ok) throw new Error('Option request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextFragment = html.querySelector('[data-high-variant-fragment]');
        if (!nextFragment) throw new Error('Option response was incomplete');
        formatQuantityOptions(nextFragment);
        updateProductUi(nextFragment);
        fragment.replaceWith(nextFragment);

        const pageUrl = new URL(productUrl, location.origin);
        pageUrl.searchParams.set('option_values', selectedValues.join(','));
        history.replaceState({}, '', pageUrl);
        const nextFocus = nextFragment.querySelector(`[data-option-name="${CSS.escape(event.target.dataset.optionName)}"]`);
        nextFocus?.focus();
      } catch (error) {
        if (error.name === 'AbortError') return;
        fragment.removeAttribute('aria-busy');
        selects.forEach(select => { select.disabled = false; });
        if (status) {
          status.textContent = fragment.dataset.errorText;
          status.classList.add('error');
        }
        showNotice({ message: fragment.dataset.errorText, field: event.target });
      }
    });
  });

  /* Phase 2 checkout agreement gate */
  document.querySelectorAll('[data-agreement-gate]').forEach(gate => {
    const viewAgreement = gate.querySelector('[data-view-agreement]');
    const agreement = gate.querySelector('[data-agreement-checkbox]');
    const acceptedAt = gate.querySelector('[data-agreement-time]');
    const help = gate.querySelector('[data-agreement-help]');
    const checkout = document.querySelector('[data-checkout-button]');
    if (!viewAgreement || !agreement || !acceptedAt || !help || !checkout) return;

    viewAgreement.addEventListener('click', () => {
      agreement.disabled = false;
      help.textContent = 'Agreement opened. Confirm acceptance to continue.';
      help.classList.add('ready');
    });

    agreement.addEventListener('change', () => {
      const accepted = agreement.checked;
      checkout.disabled = !accepted;
      checkout.textContent = accepted ? 'Continue to secure checkout' : 'Accept agreement to checkout';
      acceptedAt.value = accepted ? new Date().toISOString() : '';
      help.textContent = accepted ? 'Agreement accepted. You can continue to checkout.' : 'Confirm acceptance to continue.';
      help.classList.toggle('ready', accepted);
    });
  });

})();
